import { useContext } from "react";
import { AuthContext } from "@/context-providers/AuthContext";

export const useAuth = () => {
  const authContext = useContext(AuthContext);
  return authContext;
};
